module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAzNCAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjggMjMuNEwxMi4yIDEwLjZNMTIuMiAyMy40TDIxLjggMTAuNk0xNyAzM0MyNS44MzY4IDMzIDMzIDI1LjgzNjggMzMgMTdDMzMgOC4xNjMyIDI1LjgzNjggMSAxNyAxQzguMTYzMiAxIDEgOC4xNjMyIDEgMTdDMSAyNS44MzY4IDguMTYzMiAzMyAxNyAzM1oiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Close.svg
// module id = /Qkg
// module chunks = 1